import { getAge } from '../utils/user'

export default function (value) {
  return value ? `${getAge(value)} év` : ''
}



// WEBPACK FOOTER //
// ./src/filters/age.js